"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_spinners_1 = require("react-spinners");
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../constants");
const create_styles_1 = require("../utils/create-styles");
const LOADER_SIZE = {
    sync: {
        xs: { size: 4 },
        small: { size: 8 },
        medium: {}, // Default
    },
    fade: {
        // Sizing does not work for fade loader...
        xs: {},
        small: {},
        medium: {},
    },
};
const delayedFadeInAnimation = (0, react_1.keyframes) `
  from {
    opacity: 0;
  }

  75% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const fadeInAnimation = ({ delayed }) => {
    return delayed
        ? {
            animationDuration: '0.3s',
            animationName: delayedFadeInAnimation,
        }
        : {};
};
const StyledFadeLoader = (0, styled_1.default)(react_spinners_1.FadeLoader, {
    shouldForwardProp: (prop) => prop !== 'delayed',
})(fadeInAnimation);
const StyledSyncLoader = (0, styled_1.default)(react_spinners_1.SyncLoader, {
    shouldForwardProp: (prop) => prop !== 'delayed',
})(fadeInAnimation);
const Loader = (props) => {
    const color = props.color ?? constants_1.Color.BLUE;
    const design = props.design ?? 'sync';
    const loading = props.loading;
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: ({ css }) => {
            const className = [
                props.className,
                props.styles && css((0, create_styles_1.createStyles)(props.styles)),
            ]
                .filter(utils_1.isTruthy)
                .join(' ');
            switch (design) {
                case 'fade':
                    return ((0, jsx_runtime_1.jsx)(StyledFadeLoader, { className: className, color: color, loading: loading, delayed: props.delayed, ...LOADER_SIZE[design][props.size ?? 'medium'] }));
                case 'sync':
                    return ((0, jsx_runtime_1.jsx)(StyledSyncLoader, { className: className, color: color, loading: loading, delayed: props.delayed, ...LOADER_SIZE[design][props.size ?? 'medium'] }));
            }
        } }));
};
exports.Loader = Loader;
